import React, { PureComponent } from "react";
import { Form, Image } from "react-bootstrap";
import Select from "react-select";
import { get, filter } from "lodash";
import { onlyForCostNumbers, onlyNumbers } from "../../validation";
import DisplayByPermission from "../../component/DisplayByPermission";
import { isValidArray } from "../../helper";
import IconPlus from "../../assets/icon-plus.svg";
import { getDistrictCircle } from "../../services/apiServices";
import request from "../../services/requestService";
//import { Form, Button, Container, Row, Col, Image } from "react-bootstrap";

export class CreateProjectLocation extends PureComponent {
  state = {
    addLocation: [{}],
    error: [{}],
    costError: null,
    districtPayloadId: []
  };

  componentWillReceiveProps(nextProps, nextContext) {
    const {
      locations,
      resetForm,
      projectCost,
      updateParentStateError
    } = nextProps;
    const { locations: oldLocations, projectCost: oldProjectCost } = this.props;
    const { addLocation, error } = this.state;

    if (locations !== oldLocations) {
      locations.forEach((value, index) => {
        addLocation[index] = value;
        error[index] = { error: false, message: "" };
      });

      this.setState({
        addLocation: [...addLocation],
        error: [...error]
      });
    }

    if (oldProjectCost !== projectCost) {
      const costError = this.isCostMoreThanProjectCost(
        projectCost,
        addLocation
      );
      updateParentStateError("costError", costError);
      this.setState({
        addLocation: [...addLocation],
        error: [...error],
        costError
      });
    }

    if (resetForm) {
      this.setState({
        addLocation: [{}],
        error: [{}]
      });
    }
  }

  onRemoveLocations = index => {
    const {
      updateParentState,
      updateParentStateError,
      projectCost
    } = this.props;
    this.setState(prevState => {
      prevState.addLocation.splice(index, 1);
      prevState.error.splice(index, 1);
      const costError = this.isCostMoreThanProjectCost(
        projectCost,
        prevState.addLocation
      );
      updateParentState("locations", prevState.addLocation);
      updateParentStateError("locations", prevState.error);
      updateParentStateError("costError", costError);
      this.props.altLocation(prevState.addLocation);

      return {
        addLocation: [...prevState.addLocation],
        error: [...prevState.error],
        costError: costError
      };
    });
  };

  onAddLocations = () => {
    const {
      updateParentState,
      updateParentStateError,
      projectCost,
      iigProjectReferenceId
    } = this.props;
    this.setState(
      prevState => {
        const costError = this.isCostMoreThanProjectCost(
          projectCost,
          prevState.addLocation
        );
        return {
          addLocation: [...prevState.addLocation, {}],
          error: [{}, ...prevState.error],
          costError: costError
        };
      },
      () => {
        updateParentState("locations", this.state.addLocation);
        updateParentStateError("locations", this.state.error);
        updateParentStateError("costError", this.state.costError);
      }
    );
  };

  onChange = (value, key, mainKey, index, districtOptions) => {
    const {
      updateParentState,
      updateParentStateError,
      projectCost,
      distance,
      getDistrictListForLocation,
      onStateerrorChange
    } = this.props;

    if (key === "districtId") {
      value = value && value.length && value.map(item => item.id);
    }
    this.setState(prevState => {
      const updatedLocations = [...prevState.addLocation]; // copy the array
      const data = {
        ...updatedLocations[index], // copy the object at this index
        [key]:
          key === "distance" || key === "cost"
            ? (key === "cost" && onlyForCostNumbers(value)) ||
              onlyNumbers(value)
            : value
      };

      if (key === "id") {
        onStateerrorChange(false);
        data["cost"] = "";
        data["distance"] = "";
        data["districtId"] = [];
        data["district"] = [];
        data["districtIdName"] = [];
        data["districtList"] = [];

        // async fetch for district list
        getDistrictListForLocation(undefined, value).then(resp => {
          this.setState(prev => {
            const newLocations = [...prev.addLocation];
            newLocations[index] = {
              ...newLocations[index],
              districtList: resp.data
            };
            this.props.altLocation(newLocations, index);
            return { addLocation: newLocations };
          });
        });
      }

      if (key === "districtId") {
        data.districtIdName = filter(districtOptions, function(o) {
          return value && value.length && value.includes(o.id);
        });
      }

      updatedLocations[index] = data;

      const costValue = data.cost;
      const distanceValue = data.distance;

      let error = [...prevState.error];
      if (key === "id" && (costValue || distanceValue)) {
        error[index] = {
          error: !value,
          message: !value && "Field is required."
        };
      } else {
        const id = data.id;
        let err = !!(!id && !(costValue || distanceValue));
        let msg = err ? "Field is required" : "";
        error[index] = { error: err, message: msg };
      }

      const costError = this.isCostMoreThanProjectCost(
        projectCost,
        updatedLocations
      );

      updateParentState("locations", updatedLocations);
      updateParentStateError("locations", error);
      updateParentStateError("costError", costError);

      return {
        addLocation: updatedLocations,
        error,
        costError
      };
    });

    // this.setState(prevState => {
    //   const data = {
    //     ...prevState.addLocation[index],
    //     [key]:
    //       key === "distance" || key === "cost"
    //         ? (key === "cost" && onlyForCostNumbers(value)) ||
    //           onlyNumbers(value)
    //         : value
    //   };
    //   if (key === "id") {
    //     onStateerrorChange(false);
    //     data["cost"] = "";
    //     data["distance"] = "";
    //     data["districtId"] = [];
    //     data["district"] = [];
    //     console.log(data);
    //     getDistrictListForLocation(undefined, value).then(resp => {
    //       data["districtList"] = resp.data;
    //       this.setState({
    //         [value]: resp.data
    //       });
    //     });
    //                 console.log(data);
    //   }
    //   if (key === "districtId") {
    //     data.districtIdName = filter(districtOptions, function(o) {
    //       return value && value.length && value.includes(o.id);
    //     });
    //   }
    //   prevState.addLocation[index] = data;
    //   const costValue = prevState.addLocation[index].cost;
    //   const distanceValue = prevState.addLocation[index].distance;
    //   if (key === "id" && (costValue || distanceValue)) {
    //     if (costValue || distanceValue) {
    //       prevState.error[index] = {
    //         error: !value,
    //         message: !value && "Field is required."
    //       };
    //     } else {
    //       prevState.error[index] = {
    //         error: false,
    //         message: ""
    //       };
    //     }
    //   } else {
    //     const id = prevState.addLocation[index].id;
    //     let err = !!(!id && !(costValue || distanceValue));
    //     let msg = !!(!id && !(costValue || distanceValue))
    //       ? "Field is required"
    //       : "";

    //     prevState.error[index] = {
    //       error: err,
    //       message: msg
    //     };
    //   }

    //   // if location cost is more than project cost then throw error
    //   prevState.costError = this.isCostMoreThanProjectCost(
    //     projectCost,
    //     prevState.addLocation
    //   );
    //   updateParentState("locations", prevState.addLocation);
    //   updateParentStateError("locations", prevState.error);
    //   updateParentStateError("costError", prevState.costError);
    //   return {
    //     addLocation: [...prevState.addLocation],
    //     error: [...prevState.error],
    //     costError: prevState.costError
    //   };
    // });
  };

  sortedOptionsList = index => {
    const { addLocation } = this.state;
    const { options } = this.props;
    const clone = [...addLocation];
    clone.splice(index, 1);
    return (options || []).filter(value => {
      const isAvail = clone.find(loc => {
        return loc.id == value.id;
      });
      return !isAvail;
    });
  };

  isCostMoreThanProjectCost = (projectCost, addLocation) => {
    let cost = 0;
    addLocation.forEach(location => {
      location.cost && (cost += +location.cost);
    });
    return (
      (this.props.distance &&
        cost > projectCost && {
          error: true,
          message: "Cost is higher than Project Cost"
        }) || { error: false }
    );
  };

  handleDistrictSelectChange = async (
    value,
    actionMeta,
    index,
    param,
    selectOptions
  ) => {
    switch (actionMeta.action) {
      case "remove-value":
      case "pop-value":
        let removedValue = actionMeta.removedValue;
        if (removedValue.isFixed) {
          return;
        }
        break;
      case "clear":
        value = selectOptions.filter(option => option.isFixed);
        break;
    }
    this.onChange(value, "districtId", "locations", index, param.districtList);
  };
  render() {
    const { addLocation, costError } = this.state;
    const {
      options,
      locations,
      cost,
      distance,
      error,
      iigPayload,
      iigMappingdetails,
      originalLocations,
      iigProjectReferenceId,
      groupId,
      isUPproject,
      isEdit = false
    } = this.props;
    const {
      disabled = {
        location: false,
        addMore: false,
        district: false
      }
    } = this.props;
    //console.log(addLocation);

    const targetDate = this.props.createdDate;
    const dateAfterCrip = new Date("2026-07-08").getTime();

    const template = addLocation.map((param, index) => {
      const optionsList = this.sortedOptionsList(index);
      const optionsTemplate = (optionsList || []).map(value => {
        return (
          <option data-test="location-item" key={value.id} value={value.id}>
            {value.name}
          </option>
        );
      });

      const value = locations[index] || param;
      const state = value.name;
      const _districtOptionsForMulti = (param.districtList || []).map(item => {
        item.value = item.id;
        item.label = item.name;
        if (originalLocations) {
          let originalLocationState = originalLocations.find(
            location => location.name === state
          );
          if (
            originalLocationState !== undefined &&
            iigProjectReferenceId !== null
          ) {
            let originalLocationStateDistrictIds =
              typeof originalLocationState.districtId === "object"
                ? originalLocationState.districtId
                : [];
            item.isFixed = originalLocationStateDistrictIds.includes(item.id);
          }
        }
        return item;
      });
      let districtMapping = [];
      let districtListMapping = [];
      if (iigProjectReferenceId !== null) {
        if (isValidArray(originalLocations) !== 0) {
          const locationValues = originalLocations[index];
          districtListMapping = locationValues.districtIdName;
          districtMapping = isValidArray(districtListMapping);
        }
      }
      const errorExtract = error && error[index];
      const selectedValue = options.find(selected => {
        return +value.id === +selected.id;
      });
      param.districtId =
        param.districtId && param.districtId.length < 1
          ? param.districtIdName &&
            param.districtIdName.length &&
            param.districtIdName.map(item => item.id)
          : param.districtId;
      const _districtSelectedValue = filter(param.districtList, function(o) {
        return (
          param.districtId &&
          param.districtId.length &&
          param.districtId.includes(o.id)
        );
      });

      let isDisabled = false;
      let isClearable = true;
      if (originalLocations && iigProjectReferenceId !== null) {
        let originalLocationState = originalLocations.find(
          location => location.name === state
        );
        if (originalLocationState !== undefined) {
          let originalLocationStateDistrictIds =
            originalLocationState.districtId;
          let stateDistrictOptionsIds = _districtOptionsForMulti.map(
            item => item.id
          );
          let stateDistrictMatchedIds = originalLocationStateDistrictIds.filter(
            id => stateDistrictOptionsIds.includes(id)
          );
          // if there are one or more districts and all districts are matched
          if (
            stateDistrictMatchedIds.length &&
            stateDistrictMatchedIds.length ===
              originalLocationStateDistrictIds.length
          ) {
            isClearable = false;
            isDisabled = true;
          }
        }
      }

      let iigMappingStateText = "";
      let iigMappingDistrictsText = "";
      if (iigMappingdetails.iigLocations) {
        let iigMappingLocationState = iigMappingdetails.iigLocations.find(
          location => location.state === state
        );
        if (iigMappingLocationState) {
          iigMappingStateText = iigMappingLocationState.state;
          let iigMappingLocationStateDistricts =
            iigMappingLocationState.districtList;
          iigMappingLocationStateDistricts = iigMappingLocationStateDistricts.filter(
            district => district
          ); // remove null values
          iigMappingDistrictsText = iigMappingLocationStateDistricts.join(", ");
        }
      }

      const districtSelectStyles = {
        multiValueLabel: (base, state) => {
          return state.data.isFixed ? { ...base, paddingRight: 6 } : base;
        },
        multiValueRemove: (base, state) => {
          return state.data.isFixed ? { ...base, display: "none" } : base;
        }
      };

      return (
        <React.Fragment>
          <div className={`added-location-wrapper`}>
            <div className="added-location-detail">
              <div className="location-name">
                <div className="row">
                  <div className="col-md-6">
                    <Form.Label
                      data-test="label-location"
                      style={{ width: "inherit" }}
                    >
                      State
                      <span className="required">*</span>
                      {!disabled.addMore && optionsList.length ? (
                        index === 0 ? (
                          <></>
                        ) : (
                          <div
                            className="btn-icon delete-location"
                            style={{ position: "absolute", marginLeft: "-2em" }}
                            title="Delete"
                            onClick={() => {
                              this.onRemoveLocations(index);
                            }}
                          />
                        )
                      ) : null}
                      <Form.Control
                        data-test="location"
                        as="select"
                        key="location"
                        style={{ width: groupId == 78 ? "107%" : "104%" }}
                        value={(selectedValue && selectedValue.id) || ""}
                        onChange={e => {
                          this.onChange(
                            e.target.value,
                            "id",
                            "locations",
                            index
                          );
                        }}
                        //isInvalid={get(errorExtract, "error")}
                        isInvalid={param.id == "" || get(errorExtract, "error")}
                        disabled={
                          isValidArray(originalLocations) !== 0
                            ? disabled.location
                            : false
                        }
                      >
                        <option data-test="location-item" value="">
                          - Select State -
                        </option>
                        {optionsTemplate}
                      </Form.Control>
                      {/* <Form.Control.Feedback type="invalid">
                        {get(errorExtract, "message")}
                      </Form.Control.Feedback> */}
                      {iigProjectReferenceId !== null && (
                        <p className="remaining-char iig-sector-id">
                          <span>
                            State from{" "}
                            {targetDate >= dateAfterCrip || isEdit
                              ? "CRIP"
                              : "IIG"}
                            :&nbsp;
                            {iigMappingStateText || "N/A"}
                          </span>
                        </p>
                      )}
                      {param.id == "" || get(errorExtract, "error") ? (
                        <div class="district-mandatory-text mt-2">
                          This field is required
                        </div>
                      ) : null}
                    </Form.Label>
                  </div>
                  <div className={groupId == 78 ? "col-md-4" : "col-md-6"}>
                    <Form.Label
                      data-test="label-location"
                      style={{ width: "inherit" }}
                    >
                      District
                      <span
                        className="required"
                        style={{ display: groupId == 78 ? null : "none" }}
                      >
                        *
                      </span>
                      <div
                        className={"location-name district-name-dropdown"}
                        data-test="district-name"
                        style={{ width: groupId == 78 ? 277 : null }}
                      >
                        <Select
                          styles={districtSelectStyles}
                          defaultValue={_districtSelectedValue || []}
                          isMulti
                          name="districtId"
                          placeholder="- Select District -"
                          options={_districtOptionsForMulti}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={(value, actionMeta) => {
                            this.handleDistrictSelectChange(
                              value,
                              actionMeta,
                              index,
                              param,
                              _districtOptionsForMulti
                            );
                          }}
                          value={_districtSelectedValue || []}
                          isClearable={isClearable}
                          isDisabled={isDisabled || isUPproject}
                        />
                        {iigProjectReferenceId !== null && (
                          <p className="remaining-char iig-sector-id">
                            <span>
                              District from{" "}
                              {targetDate >= dateAfterCrip || isEdit
                                ? "CRIP"
                                : "IIG"}
                              :&nbsp;
                              {iigMappingDistrictsText || "N/A"}
                            </span>
                          </p>
                        )}
                      </div>
                    </Form.Label>
                  </div>
                </div>
              </div>
              {/* {distance && (
                <div className="location-distance">
                  <Form.Control
                    data-test="location-distance"
                    type="text"
                    placeholder="Distance"
                    value={value.distance || ""}
                    onChange={e => {
                      this.onChange(
                        e.target.value,
                        "distance",
                        "locations",
                        index
                      );
                    }}
                  />
                  <span>km</span>
                </div>
              )}
              {cost && (
                <div className="location-cost">
                  <Form.Control
                    data-test="location-cost"
                    type="text"
                    value={value.cost || ""}
                    onChange={e => {
                      this.onChange(e.target.value, "cost", "locations", index);
                    }}
                  />
                  <span>cr</span>
                </div>
              )} */}
            </div>
          </div>
        </React.Fragment>
      );
    });

    return (
      <React.Fragment>
        <div className="added-location">{template}</div>
        <div
          class="add-files add-project-map-file mt-3"
          onClick={this.onAddLocations}
          style={{
            width: 155,
            display:
              iigProjectReferenceId !== null || isUPproject ? "none" : null
          }}
        >
          <div class="d-flex" data-test="upload-project-map">
            <Image src={IconPlus} alt="Plus Icon" />
            <div class="add-file-text ml-2" style={{ marginTop: 2.5 }}>
              &nbsp;ADD MORE STATES
            </div>
          </div>
        </div>
        <DisplayByPermission display={get(costError, "error")}>
          <div className="location-cost-error">{get(costError, "message")}</div>
        </DisplayByPermission>
      </React.Fragment>
    );
  }
}

export default CreateProjectLocation;
